var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"search"},[_c('div',{staticClass:"search-icon-wrapper"},[_c('a',{class:{ active: _vm.show },attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.searchBarExpand.apply(null, arguments)}}},[_c('SearchIcon',{staticClass:"search-icon"})],1)]),_vm._v(" "),_c('SearchBar',{attrs:{"show":_vm.show}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }